import { render, staticRenderFns } from "./SetScreen.vue?vue&type=template&id=cc740538"
import script from "./SetScreen.vue?vue&type=script&lang=js"
export * from "./SetScreen.vue?vue&type=script&lang=js"
import style0 from "./SetScreen.vue?vue&type=style&index=0&id=cc740538&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports